module.exports = __webpack_public_path__ + "trademark7.png?de81fe3ca5231407ef56a717944e00b6";


//////////////////
// WEBPACK FOOTER
// ./static/assets/trademark7.png
// module id = 498
// module chunks = 0